import LanguagePicker from '@/legacy-src/components/languagePicker/LanguagePicker'

export const HeaderDesktopLanguagePicker = () => (
  <div className="hidden laptop:block">
    <LanguagePicker />
  </div>
)
